/**
 * HemSyd: tomt lage i varukorgen - BADE panelen och /cart-sidan.
 *
 * Butiken har tva olika tomma lagen, och de sag helt olika ut:
 *   1. Panelen (#hsDesktopCartModal / #hemsydMobileCartModal). Mallen i
 *      assets/vela_ajaxcart.js renderar bara en naken rad -
 *      <div class="headerCartEmpty">Din varukorg ar tom!</div> - vansterstalld
 *      hogst upp, och lamnar kvar "Rekommenderat for dig" med noll produkter.
 *   2. Varukorgssidan /cart. sections/vela-template-cart.liquid renderar
 *      <div class="cartEmptyContent"> med rubrik, brodtext och en
 *      "Ga till startsidan"-knapp - ocksa vansterstalld.
 *
 * Bada byggs har om till SAMMA centrerade lage: ikon, rubrik, kort text och en
 * "Borja handla"-knapp. I panelen doljs dessutom produktforslagen sa lange
 * korgen ar tom (pa /cart renderas de anda inte nar korgen ar tom).
 *
 * FRISTAENDE MODUL: hakar sjalv i ajaxCart.afterCartLoad (samma hook som
 * fraktbaren och presentbaren) i stallet for att anropas fran
 * assets/hs-cart-drawer.js. Da behover varken den filen eller
 * vela-template-cart.liquid rotas i.
 *
 * Stilarna injiceras harifran i stallet for att laggas i en CSS-fil: markupen
 * byggs anda av JS, sa markup och utseende hor ihop pa ett stalle. Injiceras
 * EN gang (id-kontroll).
 */
(function () {
  'use strict';

  if (window.hsCartEmptyInit) return;
  window.hsCartEmptyInit = true;

  var STYLE_ID = 'hsCartEmptyStyles';
  var SHOP_URL = '/collections/all';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var css = ''
      + '.velaAjaxCartModal.hsCartIsEmpty .hsCartMiddleWrap {'
      + '  display: flex !important;'
      + '  align-items: center !important;'
      + '  justify-content: center !important;'
      + '}'
      + '.hsCartRecommendHidden { display: none !important; }'
      + '.hsCartEmptyState {'
      + '  display: flex;'
      + '  flex-direction: column;'
      + '  align-items: center;'
      + '  text-align: center;'
      + '  padding: 32px 24px 40px;'
      + '  width: 100%;'
      + '  font-family: \'DM Sans\', sans-serif;'
      + '}'
      + '.hsCartPage .hsCartEmptyState { padding: 56px 20px 72px; }'
      + '.hsCartEmptyState svg {'
      + '  width: 52px;'
      + '  height: 52px;'
      + '  color: #c9c3ba;'
      + '  margin-bottom: 18px;'
      + '}'
      + '.hsCartEmptyTitle {'
      + '  font-family: \'Bebas Neue\', sans-serif;'
      + '  font-size: 30px;'
      + '  letter-spacing: .02em;'
      + '  text-transform: uppercase;'
      + '  color: #1a1a1a;'
      + '  margin: 0 0 8px;'
      + '  line-height: 1.1;'
      + '}'
      + '.hsCartEmptyText {'
      + '  font-size: 14px;'
      + '  line-height: 1.55;'
      + '  color: #7a7a7a;'
      + '  margin: 0 0 24px;'
      + '  max-width: 290px;'
      + '}'
      + '.hsCartEmptyBtn {'
      + '  display: flex;'
      + '  align-items: center;'
      + '  justify-content: center;'
      + '  width: 100%;'
      + '  max-width: 290px;'
      + '  padding: 15px;'
      + '  border-radius: 8px;'
      + '  font-weight: 700;'
      + '  font-size: 17px;'
      + '  line-height: 1.2;'
      + '  background: #12241d !important;'
      + '  background-image: none !important;'
      + '  color: #ffffff !important;'
      + '  border: none !important;'
      + '  box-shadow: none !important;'
      + '  text-decoration: none !important;'
      + '}'
      + '.hsCartEmptyBtn:hover {'
      + '  background: #0a1712 !important;'
      + '  color: #ffffff !important;'
      + '}';
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent = css;
    document.head.appendChild(el);
  }

  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" '
    + 'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/>'
    + '<path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';

  function fill(box) {
    if (box.dataset.hsEmptyDone) return;
    box.dataset.hsEmptyDone = '1';
    box.classList.add('hsCartEmptyState');
    box.innerHTML = ICON
      + '<p class="hsCartEmptyTitle">Din varukorg är tom</p>'
      + '<p class="hsCartEmptyText">Här var det tomt. Titta runt bland våra produkter – '
      + 'fri frakt från 399 kr och 60 dagars öppet köp.</p>'
      + '<a class="hsCartEmptyBtn" href="' + SHOP_URL + '">Börja handla</a>';
  }

  function renderModal(modalEl) {
    var container = modalEl.querySelector('#cartContainer');
    var emptyEl = container ? container.querySelector('.headerCartEmpty') : null;
    var isEmpty = !!emptyEl;

    modalEl.classList.toggle('hsCartIsEmpty', isEmpty);

    /* Produktforslagen doljs via klass, inte hidden-attributet - snippeten har
       egna display-regler som annars vinner pa specificitet. */
    var recommend = modalEl.querySelector('.hemsyd-cart-recommend');
    if (recommend) recommend.classList.toggle('hsCartRecommendHidden', isEmpty);

    if (isEmpty) fill(emptyEl);
  }

  /* /cart-sidan ar server-renderad av Liquid: .cartEmptyContent finns bara i
     DOM:en nar korgen faktiskt ar tom, sa ingen toggling behovs har. */
  function renderCartPage() {
    var box = document.querySelector('.cartEmptyContent');
    if (box) fill(box);
  }

  function renderAll() {
    injectStyles();
    var modals = document.querySelectorAll('.velaAjaxCartModal');
    for (var i = 0; i < modals.length; i++) renderModal(modals[i]);
    renderCartPage();
  }

  /* De fordrojda omkorningarna finns for att panelen ritas om asynkront -
     restructure() i hs-cart-drawer.js hinner inte alltid skapa
     .hsCartMiddleWrap innan forsta korningen, och da far centreringen inget
     att fasta i. */
  function renderSoon() {
    renderAll();
    setTimeout(renderAll, 400);
    setTimeout(renderAll, 1000);
  }

  if (window.jQuery) {
    window.jQuery('body').on('ajaxCart.afterCartLoad', renderSoon);
  }

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-hs-cart-open]')) renderSoon();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderSoon);
  } else {
    renderSoon();
  }
})();
